import { render, staticRenderFns } from "./ProcurementReportArusKas.vue?vue&type=template&id=3064fe02&"
import script from "./ProcurementReportArusKas.vue?vue&type=script&lang=js&"
export * from "./ProcurementReportArusKas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports